module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }